import React from 'react';
import { Translate } from 'react-localize-redux';
import css from '../signup/sidebar.css';
import SingularLogoIcon from '../resources/svg/singular_logo_blue_figma.svg';
import PartnerCheckIcon from '../resources/svg/partner_check_icon.svg';
import G2Logo from '../resources/svg/g2_logo.svg';
import G2Stars from '../resources/svg/g2_stars.svg';
import G2BestResults from '../resources/svg/g2_best_results.svg';
import G2BestRelationship from '../resources/svg/g2_best_relationship.svg';

const TRANSLATE_PREFIX = 'STATIC.PAGES.PARTNER_SIGNUP';

const SIDEBAR_BENEFITS = [
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_1`,
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_2`,
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_3`,
    `${TRANSLATE_PREFIX}.SIDEBAR_BENEFIT_4`,
];

export default function PartnerSidebar() {
    return (
        <div className={css.partnerSidebar}>
            <div className={css.sidebarContent}>
                <div className={css.sidebarHeader}>
                    <SingularLogoIcon className={css.sidebarLogo} />
                    <div className={css.sidebarTitle}>
                        <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_TITLE`} />
                    </div>
                    <div className={css.sidebarDescription}>
                        <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_DESCRIPTION`} />
                    </div>
                </div>
                <div className={css.sidebarBenefitsSection}>
                    <div className={css.sidebarSectionTitle}>
                        <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_WHY_TITLE`} />
                    </div>
                    <div className={css.sidebarBenefitsList}>
                        {SIDEBAR_BENEFITS.map(benefitKey => (
                            <div key={benefitKey} className={css.sidebarBenefitItem}>
                                <PartnerCheckIcon className={css.sidebarBenefitIcon} />
                                <div className={css.sidebarBenefitText}>
                                    <Translate id={benefitKey} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={css.sidebarFooter}>
                <div className={css.sidebarFooterSeparator} />
                <div className={css.sidebarFooterTitle}>
                    <Translate id={`${TRANSLATE_PREFIX}.SIDEBAR_FOOTER`} />
                </div>
                <div className={css.sidebarBadges}>
                    <div>
                        <G2Logo className={css.sidebarG2Logo} />
                        <G2Stars className={css.sidebarG2Stars} />
                    </div>
                    <G2BestResults className={css.sidebarBadge} />
                    <G2BestRelationship className={css.sidebarBadge} />
                </div>
            </div>
        </div>
    );
}